/* unknown.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 20 20" preserveAspectRatio="none">
            <path class="foreground-gl" d="M9.92,19.81a9.9,9.9,0,1,1,9.9-9.9h0A9.91,9.91,0,0,1,9.92,19.81Zm0-18.42a8.52,8.52,0,1,0,8.5,8.56,8.52,8.52,0,0,0-8.5-8.56Z" transform="translate(-0.02 -0.01)"/><path class="foreground-gl" d="M7.07,3.88A4.57,4.57,0,0,1,9.6,3.22a5.44,5.44,0,0,1,3.27.94,3.22,3.22,0,0,1,1.3,2.79,3.15,3.15,0,0,1-.56,1.91,6.52,6.52,0,0,1-1.27,1.2l-.62.48a1.87,1.87,0,0,0-.67.91,3.89,3.89,0,0,0-.11,1H8.58a6.85,6.85,0,0,1,.28-2A3.59,3.59,0,0,1,10,9.15l.63-.5a2.21,2.21,0,0,0,.5-.51,1.75,1.75,0,0,0,.35-1.05,2,2,0,0,0-.39-1.21,1.62,1.62,0,0,0-1.41-.54A1.56,1.56,0,0,0,8.28,6,2.58,2.58,0,0,0,7.86,7.4H5.34A4.06,4.06,0,0,1,7.07,3.88Zm1.45,9.79h2.6v2.52H8.52Z" transform="translate(-0.02 -0.01)"/>
            </svg>
         `,
};
